export default "__VITE_ASSET__BAV139ry__"